export const ErrorCode = {
    UNAUTHENTICATED: 'UNAUTHENTICATED',
    INIT_DATA_INVALID: 'INIT_DATA_INVALID',
    INVALID_CREDENTIALS: 'INVALID_CREDENTIALS',
    PASSWORD_CHANGE_REQUIRED: 'PASSWORD_CHANGE_REQUIRED',
    FORBIDDEN: 'FORBIDDEN',
    NOT_FOUND: 'NOT_FOUND',
    VALIDATION_FAILED: 'VALIDATION_FAILED',
    RATE_LIMITED: 'RATE_LIMITED',
    SUBSCRIPTION_REQUIRED: 'SUBSCRIPTION_REQUIRED',
    PLAN_LIMIT_REACHED: 'PLAN_LIMIT_REACHED',
    SHOP_UNAVAILABLE: 'SHOP_UNAVAILABLE',
    SLUG_TAKEN: 'SLUG_TAKEN',
    SLUG_RESERVED: 'SLUG_RESERVED',
    SLUG_INVALID: 'SLUG_INVALID',
    BOT_USERNAME_INVALID: 'BOT_USERNAME_INVALID',
    BOT_USERNAME_TAKEN: 'BOT_USERNAME_TAKEN',
    BOT_LIMIT_TELEGRAM: 'BOT_LIMIT_TELEGRAM',
    OUT_OF_STOCK: 'OUT_OF_STOCK',
    COUPON_INVALID: 'COUPON_INVALID',
    COUPON_EXPIRED: 'COUPON_EXPIRED',
    COUPON_EXHAUSTED: 'COUPON_EXHAUSTED',
    COUPON_MIN_NOT_MET: 'COUPON_MIN_NOT_MET',
    ORDER_STATE_INVALID: 'ORDER_STATE_INVALID',
    RECEIPT_REQUIRED: 'RECEIPT_REQUIRED',
    FILE_TYPE_NOT_ALLOWED: 'FILE_TYPE_NOT_ALLOWED',
    FILE_TOO_LARGE: 'FILE_TOO_LARGE',
    IDEMPOTENCY_CONFLICT: 'IDEMPOTENCY_CONFLICT',
    OPEN_ORDERS_LIMIT: 'OPEN_ORDERS_LIMIT',
    ALREADY_DECIDED: 'ALREADY_DECIDED',
    INTERNAL_ERROR: 'INTERNAL_ERROR',
};
export const ErrorHttpStatusMap = {
    [ErrorCode.UNAUTHENTICATED]: 401,
    [ErrorCode.INIT_DATA_INVALID]: 401,
    [ErrorCode.INVALID_CREDENTIALS]: 401,
    [ErrorCode.PASSWORD_CHANGE_REQUIRED]: 403,
    [ErrorCode.FORBIDDEN]: 403,
    [ErrorCode.NOT_FOUND]: 404,
    [ErrorCode.VALIDATION_FAILED]: 422,
    [ErrorCode.RATE_LIMITED]: 429,
    [ErrorCode.SUBSCRIPTION_REQUIRED]: 402,
    [ErrorCode.PLAN_LIMIT_REACHED]: 409,
    [ErrorCode.SHOP_UNAVAILABLE]: 403,
    [ErrorCode.SLUG_TAKEN]: 409,
    [ErrorCode.SLUG_RESERVED]: 422,
    [ErrorCode.SLUG_INVALID]: 422,
    [ErrorCode.BOT_USERNAME_INVALID]: 422,
    [ErrorCode.BOT_USERNAME_TAKEN]: 409,
    [ErrorCode.BOT_LIMIT_TELEGRAM]: 409,
    [ErrorCode.OUT_OF_STOCK]: 409,
    [ErrorCode.COUPON_INVALID]: 422,
    [ErrorCode.COUPON_EXPIRED]: 409,
    [ErrorCode.COUPON_EXHAUSTED]: 409,
    [ErrorCode.COUPON_MIN_NOT_MET]: 422,
    [ErrorCode.ORDER_STATE_INVALID]: 409,
    [ErrorCode.RECEIPT_REQUIRED]: 422,
    [ErrorCode.FILE_TYPE_NOT_ALLOWED]: 422,
    [ErrorCode.FILE_TOO_LARGE]: 413,
    [ErrorCode.IDEMPOTENCY_CONFLICT]: 409,
    [ErrorCode.OPEN_ORDERS_LIMIT]: 409,
    [ErrorCode.ALREADY_DECIDED]: 409,
    [ErrorCode.INTERNAL_ERROR]: 500,
};
//# sourceMappingURL=codes.js.map